import React from "react";
import AccountsOverviewTable from "../../components/Accounts/AccountOverviewTable/AccountsOverviewTable";

const AccountOverviewPage: React.FC<{}> = (props) => {
  return <AccountsOverviewTable />;
};

export default AccountOverviewPage;
